<template>
    <Header></Header>
    <div class="main-bg">
        <div class="wrap">
            <div class="main-box flex flex-col justify-center text-center">
                <div class="error-img">
                    <picture>
                      <source :srcset="staticURL('/images/error.webp')" type="image/webp">
                      <img :src="staticURL('/images/error.png')" alt="404">
                    </picture>
                </div>
                <!-- <h1 class="font16 color-f">{{ t('common.pageNotFound') }}</h1> -->
                <div class="btn-default auto" @click="goBack">{{ t('common.backHome') }}</div>
            </div>
        </div>
    </div>
    <Footer></Footer>

</template>
<script setup lang="ts">
    import { useI18n } from 'vue-i18n'
    import { useRouter } from 'vue-router';
    const router = useRouter();
    const fallbackText: Record<string, string> = {
      'common.pageNotFound': '页面不见了，请稍后重试',
      'common.back': '返回',
      'common.backHome': '返回首页',
    }
    let t = (key: string) => fallbackText[key] || key
    try {
      const i18n = useI18n()
      t = i18n.t
    } catch {
      /* i18n 未就绪时使用中文兜底 */
    }

    const goBack = () => {
        router.push('/')
    }
</script>
<style scoped lang="scss">
    .main-bg{
        padding: 75px 0;
        .main-box{
            min-height: calc(100vh - 485px);
            // background-color: var(--main-color);
            .error-img{
                img{
                    display: block;
                    width: auto;
                    max-height: 188px;
                    margin: 0 auto;
                }
            }
            h1{
                margin: 11px 0 12px;
                font-weight: normal;
            }
            .btn-default{
                width: 130px;
            }
        }
    }
    
    @media only screen and (max-width:991px){
        .main-bg{
            padding: 75px 0 30px;
            .main-box{
                min-height: calc(100vh - 105px);
            }
        }
    }
    @media only screen and (max-width:767px){
        .main-bg{
            padding: 50px 0 30px;
            .main-box{
                min-height: calc(100vh - 85px);
                .error-img{
                    img{
                        height: 2.8rem;
                    }
                }
            }
        }

    }
</style>
